export const splitPath = (path: string) => {
  return path.split("/").filter((segment) => segment);
};

export const formatTitle = (segment: string) => {
  return segment.replace(/-/g, " ").replace(/\b\w/g, (char) => char);
};
